export const clippingBillingBasePath = '/api/clipping_billing.php';
